export default "__VITE_ASSET__CHrFWLsg__"